frappe.ready(function() {
    var docName = $('#quotationName').val();
    var workflowState = $('#workflowState').val();

    if (workflowState === 'Approved By Customer' || workflowState === 'Rejected') {
        $('#quotationButtons').hide();
    }

    $('#approveButton').click(function() {
        updateQuotationStatus(docName, 'Approved By Customer');
    });

    $('#rejectButton').click(function() {
        updateQuotationStatus(docName, 'Rejected');
    });

    function updateQuotationStatus(name, status) {
        frappe.call({
            method: 'frappe.client.set_value',
            args: {
                doctype: 'Quotation',
                name: name,
                fieldname: 'workflow_state',
                value: status
            },
            callback: function(r) {
                if (r.message) {
                    frappe.show_alert({
                        message: __('Quotation {0} updated to {1}', [name, status]),
                        indicator: 'green'
                    });
                    $('#quotationButtons').hide();
                    setTimeout(function() {
                        window.location.reload();
                    }, 2000);
                } else {
                    frappe.show_alert({
                        message: __('Failed to update Quotation {0}', [name]),
                        indicator: 'red'
                    });
                }
            },
            error: function(r) {
                frappe.show_alert({
                    message: __('Error updating Quotation {0}', [name]),
                    indicator: 'red'
                });
            }
        });
    }
});
